import { Injectable, Renderer2 } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class ThemeService {
    currentTheme: string = 'deesha';

    constructor(){}
    
    get  ActiveTheme():string{
        return this.currentTheme;
    }

    get  ActiveThemeClass():string{
        return `${this.currentTheme}-theme`;
    }
    

    toggleTheme(renderer: Renderer2, theme_name:string ='') : Promise<string> {
        const themeClass = theme_name==''?'deesha':theme_name;
        const body = document.body;

        return new Promise((resolve)=>{
            try{
                
                // Step 1: Add fade class to start fade-out
                renderer.addClass(body, 'fade-transition');
                

                // Step 2: After fade-out, change theme and fade back in
                setTimeout(() =>{
                    renderer.removeClass(body, `${this.currentTheme}-theme`);
                    
                    this.currentTheme=themeClass;
                    renderer.addClass(body, `${themeClass}-theme`);
                    renderer.addClass(body, 'has-theme');
                    renderer.removeClass(body, 'no-theme');
                    
                    resolve(themeClass);
                    setTimeout(() => {
                        // Start fade-in
                        renderer.removeClass(body, 'fade-transition');
                    }, 200);
                    
                    
                }
                , 400);
            }
            catch{
                resolve(themeClass);
            }
            
           
        });
        
        
    }
}